import React from 'react';
import { Building2, Layers, Users } from 'lucide-react';
import type { OrgOperationType } from '@court-sync/shared';
import { SelectableCard, SelectableCardGrid } from './SelectableCard';

const OPTIONS: Array<{
  value: OrgOperationType;
  title: string;
  description: string;
  icon: React.ReactNode;
}> = [
  {
    value: 'academy',
    title: 'Academy',
    description: 'Run lessons, terms, camps, and coaching programs.',
    icon: <Users className="h-5 w-5" />,
  },
  {
    value: 'club',
    title: 'Club',
    description: 'Manage courts, court hire, memberships, match play, and facility operations.',
    icon: <Building2 className="h-5 w-5" />,
  },
  {
    value: 'both',
    title: 'Academy & club',
    description: 'Run programs and operate your club facility on one platform.',
    icon: <Layers className="h-5 w-5" />,
  },
];

export interface OrgOperationTypeStepProps {
  value?: OrgOperationType;
  onChange: (value: OrgOperationType) => void;
}

export function OrgOperationTypeStep({ value, onChange }: OrgOperationTypeStepProps) {
  return (
    <SelectableCardGrid label="Organization type" className="sm:grid-cols-1">
      {OPTIONS.map((option) => (
        <SelectableCard
          key={option.value}
          id={`operation-type-${option.value}`}
          title={option.title}
          description={option.description}
          icon={option.icon}
          selected={value === option.value}
          onSelect={() => onChange(option.value)}
        />
      ))}
    </SelectableCardGrid>
  );
}
